<template>
  <heading tag="h3">Tu nous quittes</heading>
  <DisplayGridCards>
    <AccountButton theme="neutral" aspect="4-3" @click="confirmLogout">
      <template #icon>
        <icon name="exit" size="4rem" />
      </template>
      {{ $t('logout.button') }}
    </AccountButton>
    <AccountButton theme="neutral" aspect="4-3" @click="confirmDelete">
      <template #icon>
        <icon name="trash" size="4rem" />
      </template>
      {{ $t('delete.button') }}
    </AccountButton>
  </DisplayGridCards>
</template>
<script setup lang="ts">
const { confirmDelete } = useAccountDelete();
const { confirmLogout } = useAccountLogout();
</script>
